<template>
  <div v-if="!loading">
    <form>
      <v-layout
        wrap
        align-center
        justify-space-between
      >
        <v-flex
          xs12
          md2
        >
          <v-select
            v-model="form.vek"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.vek"
            label="Vek"
            name="Vek"
            :error-messages="errors.collect('Vek')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('vek')"
          />
        </v-flex>

        <v-flex
          xs12
          md3
        >
          <v-select
            v-model="form.pohlavie"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.pohlavie"
            label="Pohlavie"
            name="Pohlavie"
            :error-messages="errors.collect('Pohlavie')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('pohlavie')"
          />
        </v-flex>

        <v-flex
          xs12
          md4
        >
          <v-select
            v-model="form.vo_vtos"
            v-validate="'required'"
            :disabled="form.closed"
            label="Vo výkone trestu odňatia slobody"
            :items="selects.vo_vtos"
            name="Vo výkone trestu odňatia slobody"
            :error-messages="errors.collect('Vo výkone trestu odňatia slobody')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('vo_vtos')"
          />
        </v-flex>
      </v-layout>

      <v-select
        v-model="form.najvyssie_dosiahnute_vzdelanie"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.najvyssie_dosiahnute_vzdelanie"
        label="Najvyššie dosiahnuté vzdelanie"
        name="Najvyššie dosiahnuté vzdelanie"
        :error-messages="errors.collect('Najvyššie dosiahnuté vzdelanie')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('najvyssie_dosiahnute_vzdelanie')"
      />

      <v-select
        v-model="form.aktualne_odsudeny_za"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.aktualne_odsudeny_za"
        label="Aktuálne odsúdený za"
        name="Aktuálne odsúdený za"
        :error-messages="errors.collect('Aktuálne odsúdený za')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('aktualne_odsudeny_za')"
      />

      <v-checkbox
        v-model="form.porusenie_podmienky"
        :disabled="form.closed"
        label="Porušenie podmienky (5 rokov pred nástupom na VTOS)"
        name="Porušenie podmienky (5 rokov pred nástupom na VTOS)"
        :error-messages="
          errors.collect('Porušenie podmienky (5 rokov pred nástupom na VTOS)')
        "
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('porusenie_podmienky')"
      />

      <v-checkbox
        v-model="form.clenstvo_v_zlocineckej"
        :disabled="form.closed"
        label="Členstvo v zločineckej skupine (aktuálne odsúdenie)"
        name="Členstvo v zločineckej skupine (aktuálne odsúdenie)"
        :error-messages="
          errors.collect('Členstvo v zločineckej skupine (aktuálne odsúdenie)')
        "
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('clenstvo_v_zlocineckej')"
      />

      <v-layout
        wrap
        justify-space-between
      >
        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.aktualna_dlzka_nepretrziteho_pobytu"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.aktualna_dlzka_nepretrziteho_pobytu"
            label="Aktuálna dĺžka nepretržitého pobytu vo výkone trestu odňatia slobody"
            name="Aktuálna dĺžka nepretržitého pobytu vo výkone trestu odňatia slobody"
            :error-messages="
              errors.collect(
                'Aktuálna dĺžka nepretržitého pobytu vo výkone trestu odňatia slobody'
              )
            "
            required
            append-icon="mdi-information-outline"
            @click:append="
              appendIconCallback('aktualna_dlzka_nepretrziteho_pobytu')
            "
          />
        </v-flex>

        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.dlzka_zamestnania_rok_pred"
            v-validate="'required'"
            class="text-wrap"
            style="font-size: 0.8em"
            :disabled="form.closed"
            :items="selects.dlzka_zamestnania_rok_pred"
            label="Dĺžka zamestnania rok pred nástupom do výkonu trestu odňatia slobody"
            name="Dĺžka zamestnania rok pred nástupom do výkonu trestu odňatia slobody"
            :error-messages="
              errors.collect(
                'Dĺžka zamestnania rok pred nástupom do výkonu trestu odňatia slobody'
              )
            "
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('dlzka_zamestnania_rok_pred')"
          >
            <template v-slot:item="{ _active, item, attrs, on }">
              <v-list-item
                #default="{ _active_ }"
                v-bind="attrs"
                v-on="on"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    <v-row
                      no-gutters
                      align="center"
                      style="font-size: 0.8em"
                    >
                      {{ item }}
                      <v-spacer />
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>

          <!-- <v-select
            style="font-size: 1em"
            :disabled="form.closed"
            v-model="form.dlzka_zamestnania_rok_pred"
            :items="selects.dlzka_zamestnania_rok_pred"
            label="Dĺžka zamestnania rok pred nástupom do výkonu trestu odňatia slobody"
            v-validate="'required'"
            name="Dĺžka zamestnania rok pred nástupom do výkonu trestu odňatia slobody"
            :error-messages="
              errors.collect(
                'Dĺžka zamestnania rok pred nástupom do výkonu trestu odňatia slobody'
              )
            "
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('dlzka_zamestnania_rok_pred')"
          ></v-select> -->
        </v-flex>
      </v-layout>

      <v-select
        v-model="form.spolupraca_s_inymi_org"
        v-validate="'required'"
        class="text-wrap"
        style="font-size: 0.8em"
        :disabled="form.closed"
        :items="selects.spolupraca_s_inymi_org"
        label="Spolupráca s inými organizáciami v rámci postpenitenciárnej starostlivosti"
        name="Spolupráca s inými organizáciami v rámci postpenitenciárnej starostlivosti"
        :error-messages="
          errors.collect(
            'Spolupráca s inými organizáciami v rámci postpenitenciárnej starostlivosti'
          )
        "
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('spolupraca_s_inymi_org')"
      >
        <template v-slot:item="{ _active, item, attrs, on }">
          <v-list-item
            #default="{ _active_ }"
            v-bind="attrs"
            v-on="on"
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-row
                  no-gutters
                  align="center"
                  style="font-size: 0.8em"
                >
                  {{ item }}
                  <v-spacer />
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-select>

      <!-- <v-select
        class="text-wrap"
        style="font-size: 1em"
        :disabled="form.closed"
        v-model="form.spolupraca_s_inymi_org"
        :items="selects.spolupraca_s_inymi_org"
        label="Spolupráca s inými organizáciami v rámci postpenitenciárnej starostlivosti"
        v-validate="'required'"
        name="Spolupráca s inými organizáciami v rámci postpenitenciárnej starostlivosti"
        :error-messages="
          errors.collect(
            'Spolupráca s inými organizáciami v rámci postpenitenciárnej starostlivosti'
          )
        "
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('spolupraca_s_inymi_org')"
      ></v-select> -->

      <v-select
        v-model="form.zabezpecenie_byvania_po"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.zabezpecenie_byvania_po"
        label="Zabezpečenie bývania po prepustení z výkonu trestu odňatia slobody"
        name="Zabezpečenie bývania po prepustení z výkonu trestu odňatia slobody"
        :error-messages="
          errors.collect(
            'Zabezpečenie bývania po prepustení z výkonu trestu odňatia slobody'
          )
        "
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('zabezpecenie_byvania_po')"
      />

      <v-select
        v-model="form.aktualna_financna_situacia"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.aktualna_financna_situacia"
        label="Aktuálna finančná situácia"
        name="Aktuálna finančná situácia"
        :error-messages="errors.collect('Aktuálna finančná situácia')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('aktualna_financna_situacia')"
      />

      <v-select
        v-model="form.pritomnost_soc_pat_javov"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.pritomnost_soc_pat_javov"
        label="Prítomnosť sociálno-patologických javov v rodine"
        name="Prítomnosť sociálno-patologických javov v rodine"
        :error-messages="
          errors.collect('Prítomnosť sociálno-patologických javov v rodine')
        "
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('pritomnost_soc_pat_javov')"
      />

      <v-select
        v-model="form.vychovne_prostredie"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.vychovne_prostredie"
        label="Výchovné prostredie"
        name="Výchovné prostredie"
        :error-messages="errors.collect('Výchovné prostredie')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('vychovne_prostredie')"
      />

      <v-layout
        row
        wrap
        pt-5
      >
        <v-flex xs12>
          <v-subheader class="pl-0">
            Expertné posúdenie - pravdepodobnosť, že posudzovaná osoba sa
            dopustí trestnej činnosti do 2 rokov od prepustenia
          </v-subheader>
          <v-slider
            v-model="form.expertne_posudenie"
            :readonly="form.closed"
            :tick-labels="selects.expertne_posudenie"
            always-dirty
            min="1"
            max="3"
            ticks="always"
            :color="color"
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('expertne_posudenie')"
          />
        </v-flex>
      </v-layout>

      <v-divider class="mt-10" />

      <v-textarea
        v-model="form.poznamky"
        :disabled="form.closed"
        label="Poznámky a doplňujúce informácie"
        auto-grow
        rows="1"
      />

      <v-select
        v-model="form.nepravdive_zavadzajuce"
        v-validate="'required'"
        style="font-size: 1em"
        :disabled="form.closed"
        :items="selects.nepravdive_zavadzajuce"
        label="Nepravdivé/zavádzajúce informácie"
        name="Nepravdivé/zavádzajúce informácie"
        :error-messages="errors.collect('Nepravdivé/zavádzajúce informácie')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('nepravdive_zavadzajuce')"
      />

      <v-divider class="mt-10" />

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          dark
          color="indigo"
          @click="updateItem"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
        <v-btn
          dark
          color="red"
          @click="closeItem"
        >
          Uložiť a uzatvoriť
        </v-btn>
      </v-layout>
      <v-layout
        v-else
        pt-5
      >
        <div class="flex-grow-1" />
        <v-btn
          v-if="!craItem.closed"
          dark
          color="green"
          @click="openItem"
        >
          Otvoriť
        </v-btn>
      </v-layout>
    </form>

    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <tooltip-component
        :dialog_item="dialog_item"
        :on_close="closeTooltipDialog"
      />
    </v-dialog>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="complex" />
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";
import { Tooltips } from "@/assets/tooltips";
import TooltipComponent from "./TooltipComponent.vue";
import FormSkeleton from "../../components/FormSkeleton.vue";

Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();
const tooltips = new Tooltips();

export default {
  $_veeValidate: {
    validator: "new",
  },

  components: {
    "tooltip-component": TooltipComponent,
    "form-skeleton-component": FormSkeleton,
  },

  data: () => ({
    loading: false,
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_item: {
      nazov: "",
      charakteristika: [],
      zdroj: [],
      poznamka: [],
      priklad: [],
    },

    form: {
      id: null,
      vek: "",
      pohlavie: "",
      vo_vtos: "",
      najvyssie_dosiahnute_vzdelanie: "",
      aktualne_odsudeny_za: "",
      porusenie_podmienky: "",
      clenstvo_v_zlocineckej: "",
      aktualna_dlzka_nepretrziteho_pobytu: "",
      dlzka_zamestnania_rok_pred: "",
      spolupraca_s_inymi_org: "",
      zabezpecenie_byvania_po: "",
      aktualna_financna_situacia: "",
      pritomnost_soc_pat_javov: "",
      vychovne_prostredie: "",
      nepravdive_zavadzajuce: "",

      expertne_posudenie: "",

      closed: false,
    },

    craItem: {
      closed: true,
    },

    selects: {
      vek: [
        "14 – 18 rokov",
        "19 – 30 rokov",
        "31 – 50 rokov",
        "51 – 60 rokov",
        "61 a viac rokov",
      ],
      pohlavie: ["muž", "žena"],
      vo_vtos: ["1 krát", "2 krát", "3 a viackrát"],
      najvyssie_dosiahnute_vzdelanie: [
        "III. stupeň vysokej školy",
        "II. stupeň vysokej školy",
        "I. stupeň vysokej školy",
        "úplné stredné všeobecné vzdelanie s maturitou (gymnázium)",
        "úplné stredné odborné vzdelávanie s maturitou",
        "stredné odborné vzdelanie bez maturity s výučným listom/resp. záučným listom",
        "špeciálna škola",
        "ukončená základná škola",
        "neukončený II. stupeň základnej školy",
        "neukončený I. stupeň základnej školy",
        "negramotný",
      ],
      aktualne_odsudeny_za: [
        "prečin spáchaný bez použitia násilia",
        "prečin spáchaný za použitia násilia alebo jeho hrozby",
        "zločin spáchaný bez použitia násilia",
        "zločin spáchaný za použitia násilia alebo jeho hrozby",
        "obzvlášť závažný zločin spáchaný bez použitia násilia",
        "obzvlášť závažný zločin spáchaný za použitia násilia alebo jeho hrozby",
      ],
      aktualna_dlzka_nepretrziteho_pobytu: [
        "0 – 1 rok",
        "viac ako 1 rok a menej ako 2 roky",
        "2 roky – 5 rokov",
        "viac ako 5 rokov",
      ],

      dlzka_zamestnania_rok_pred: [
        "Zamestnaný nepretržite celých 12 mesiacov pred nástupom do VTOS",
        "Zamestnaný nepretržite 12 mesiacov pred nástupom do VTOS, s fluktuáciou v rámci zamestnaní v počte 3 a viac krát za posledných 12 mesiacov.",
        "Zamestnaný menej ako 12 mesiacov - 3 mesiace",
        "Zamestnaný menej ako 3 mesiace",
        "Nezamestnaný nepretržite 12 mesiacov pred nástupom do VTOS",
      ],
      spolupraca_s_inymi_org: [
        "aktívne spolupracuje s inými profesionálnymi orgánmi, organizáciami a osobami podporujúcimi a asistujúcimi pri návrate z výkonu trestu na slobodu (napr. orgán SPODaSK, MVO, PMÚ a pod.) / z objektívnych príčin nie je spolupráca nevyhnutná",
        "spolupracuje s inými profesionálnymi orgánmi, organizáciami a osobami podporujúcimi a asistujúcimi pri návrate z výkonu trestu na slobodu (napr. orgán SPODaSK, MVO, PMÚ a pod.)",
        "nespolupracuje s inými profesionálnymi orgánmi, organizáciami a osobami podporujúcimi a asistujúcimi pri návrate z výkonu trestu na slobodu (napr. orgán SPODaSK, MVO, PMÚ a pod.)",
      ],
      aktualna_financna_situacia: [
        "bez dlhov",
        "zdokumentované aktuálne dlhy nepresahujú sumu 2.500 €",
        "zdokumentované aktuálne dlhy presahujú sumu 2.500 €",
      ],
      zabezpecenie_byvania_po: [
        "má zabezpečené dlhodobé bývanie po ukončení VTOS",
        "má zabezpečené krátkodobé bývanie po ukončení VTOS",
        "nemá zabezpečené bývanie po ukončení VTOS",
      ],

      pritomnost_soc_pat_javov: [
        "bez prítomnosti sociálno - patologických javov",
        "s prítomnosťou sociálno - patologických javov",
      ],

      vychovne_prostredie: [
        "vyrastal v rodine",
        "bol umiestnený v centre pre deti a rodiny (predtým: detský domov, krízové stredisko, resocializačné stredisko)",
        "bol umiestnený v špeciálnom výchovnom zariadení (diagnostické centrum, reedukačné centrum, liečebno – výchovné sanatórium)",
      ],
      expertne_posudenie: ["malá", "stredná", "vysoká"],
      nepravdive_zavadzajuce: [
        "podľa výsledkov náhodného overenia vybraných informácii poskytovaných odsúdeným odsúdený UVIEDOL nepravdivé/zavádzajúce informácie pri hodnotení, vo vstupnom dotazníku a pri pohovoroch",
        "podľa výsledkov náhodného overenia vybraných informácii poskytovaných odsúdeným odsúdený NEUVIEDOL nepravdivé/zavádzajúce informácie pri hodnotení, vo vstupnom dotazníku a pri pohovoroch",
      ],
    },

    manual: tooltips.rizikoveFaktory,
  }),

  computed: {
    color() {
      if (this.form.expertne_posudenie == 0) return "grey";
      if (this.form.expertne_posudenie == 1) return "green";
      if (this.form.expertne_posudenie == 2) return "orange";
      if (this.form.expertne_posudenie == 3) return "red";
      return "grey";
    },
  },

  created() {
    this.getItem();
  },

  methods: {
    closeTooltipDialog() {
      this.dialog = false;
    },

    appendIconCallback(nazov) {
      this.dialog = true;
      this.dialog_item = this.manual[nazov];
    },

    clear() {
      this.form.vek = "";
      this.form.pohlavie = "";
      this.form.vo_vtos = "";
      this.form.najvyssie_dosiahnute_vzdelanie = "";
      this.form.aktualne_odsudeny_za = "";
      this.form.porusenie_podmienky = "";
      this.form.clenstvo_v_zlocineckej = "";
      this.form.aktualna_dlzka_nepretrziteho_pobytu = "";
      this.form.dlzka_zamestnania_rok_pred = "";
      this.form.spolupraca_s_inymi_org = "";
      this.form.zabezpecenie_byvania_po = "";
      this.form.aktualna_financna_situacia = "";
      this.form.pritomnost_soc_pat_javov = "";
      this.form.vychovne_prostredie = "";
      this.form.expertne_posudenie = "";
    },
    getItem() {
      this.loading = true;
      var numberOfItemsToLoad = 2;
      apiService.getRizikoveFaktory(this.$route.params.id).then((response) => {
        this.form = response;
        numberOfItemsToLoad--;
        if (numberOfItemsToLoad == 0) {
          this.loading = false;
        }
      });
      apiService.getCraForm(this.$route.params.id).then((response) => {
        this.craItem = response;
        numberOfItemsToLoad--;
        if (numberOfItemsToLoad == 0) {
          this.loading = false;
        }
      });
    },
    updateItem() {
      apiService.updateRizikoveFaktory(this.form, this.$route.params.id).then(
        () => {
          this.snackbar_saved = true;

          this.$root.$emit("ecra_part_updated");
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },

    openItem() {
      apiService
        .updateRizikoveFaktory(
          { id: this.form.id, closed: false },
          this.$route.params.id
        )
        .then(
          (response) => {
            this.snackbar_saved = true;
            this.form = response;

            this.$root.$emit("ecra_part_updated");
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },

    closeItem() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          if (
            confirm(
              "Naozaj chcete uložiť a uzatvoriť túto časť formulára? (Následne nebude možné už formulár upravovať)"
            )
          ) {
            this.form.closed = true;

            apiService
              .updateRizikoveFaktory(this.form, this.$route.params.id)
              .then(
                (response) => {
                  this.snackbar_saved = true;
                  this.form = response;

                  this.$root.$emit("ecra_part_updated");
                },
                () => {
                  this.snackbar_error = true;
                }
              );
          }
        } else {
          alert("Všetky položky musia byť vyplnené.");
        }
      });
    },
  },
};
</script>